import { AppContextState } from './types';

/**
 * Initial App Context State
 * @type {AppContextState}
 */
export const initialAppContextState: AppContextState = {
  isMobile: false,
  isDark: false,
  systemId: '',
  tenantId: '',
  userId: '',
};
